// Concrete renderer implementations arrive in later milestones.
export const defaultPartRenderers = {};